import React from 'react';
import { Link } from 'react-router';
import { Card } from '../../../components/Card';
import { Section } from '../../../components/Section';
import { Button } from '../../../components/Button';
import useTheme from '../../../hooks/useTheme';
import { megaGreenData } from '../../../data/data';

interface InsightsTeaserProps {
    index?: number;
}

export const InsightsTeaser: React.FC<InsightsTeaserProps> = ({ index }) => {
    const { theme, breakpoint } = useTheme();
    const featuredInsightSlugs = megaGreenData.home.featuredInsights;
    const allInsights = megaGreenData.insights.articles;
    const featuredInsights = featuredInsightSlugs
        .map(slug => allInsights.find(i => i.slug === slug))
        .filter((insight): insight is NonNullable<typeof insight> => insight !== undefined);

    return (
        <Section index={index}>
            <h2
                style={{
                    fontSize: breakpoint.xs || breakpoint.sm ? '28px' : '34px',
                    fontWeight: 700,
                    color: theme.text.primary,
                    marginBottom: '48px',
                }}
            >
                Insights
            </h2>

            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: breakpoint.xs || breakpoint.sm ? '1fr' : 'repeat(3, 1fr)',
                    gap: '24px',
                    marginBottom: '32px',
                }}
            >
                {featuredInsights.map((insight) => (
                    <Card key={insight.slug} hoverable style={{ display: 'flex', flexDirection: 'column' }}>
                        <img src={insight.src} alt={insight.title} style={{ width: '100%', height: 160, objectFit: 'cover', borderRadius: theme.borderRadius.r1 }} />
                        <h3
                            style={{
                                fontSize: '18px',
                                fontWeight: 600,
                                color: theme.text.primary,
                                marginBottom: '8px',
                            }}
                        >
                            {insight.title}
                        </h3>
                        <p
                            style={{
                                fontSize: '14px',
                                color: theme.text.muted,
                                lineHeight: 1.5,
                                marginBottom: '16px',
                            }}
                        >
                            {insight.deck}
                        </p>
                        <Link to={`/insights/${insight.slug}`} style={{ textDecoration: 'none', marginTop: 'auto' }}>
                            <Button variant="secondary" style={{ width: '100%' }}>
                                Read
                            </Button>
                        </Link>
                    </Card>
                ))}
            </div>

            <div style={{ textAlign: 'center' }}>
                <Link to="/insights" style={{ textDecoration: 'none' }}>
                    <Button variant="secondary">View all insights</Button>
                </Link>
            </div>
        </Section>
    );
};

